import classNames from 'classnames';
import React from 'react';

type ToggleProps = {
    value: boolean;
    onChangeValue: (value: boolean) => void;
    className?: string;
    id?: string;
};

function supportsIosSwitch(): boolean {
    if (typeof document === 'undefined') return false;
    const input = document.createElement('input') as any;
    return typeof input.switch === 'boolean';
}

export function Toggle({ value, onChangeValue, className, id }: ToggleProps) {
    return (
        <div className={className}>
            {supportsIosSwitch() ? (
                <input
                    type="checkbox"
                    {...(id ? { id } : {})}
                    checked={value}
                    onChange={(e) => onChangeValue(e.target.checked)}
                    switch=""
                />
            ) : (
                <>
                    <input
                        type="checkbox"
                        {...(id ? { id } : {})}
                        checked={value}
                        onChange={(e) => onChangeValue(e.target.checked)}
                        className="hidden"
                    />
                    <div
                        className={classNames(
                            'flex h-[30px] w-[50px] cursor-pointer items-center rounded-full p-2 transition-all duration-300',
                            value ? 'bg-success' : 'bg-grey-500',
                        )}
                        onClick={() => onChangeValue(!value)}
                    >
                        <div
                            className={classNames(
                                'h-[26px] w-[26px] rounded-full bg-white transition-transform duration-300',
                                value ? 'translate-x-[20px]' : 'translate-x-0',
                            )}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
